import isString from './is-string';

const parseStringBoolean = (string) => !!(isString(string) && string.toLowerCase() === 'true');

export default parseStringBoolean;
